export const adFree = (user) => !!user?.ad_free_until && new Date(user.ad_free_until) > new Date();
